import {getDefaultConfig} from "@rainbow-me/rainbowkit";
import {http} from "wagmi";
import {ritualChain} from "./chain";
import {WALLETCONNECT_PROJECT_ID} from "./config";

/**
 * wagmi + RainbowKit config. RainbowKit handles connect/disconnect and the
 * account/chain-change lifecycle. Ritual is the only chain; the app also offers
 * to add/switch to it via wallet_addEthereumChain (see ChainGuard).
 */
export const wagmiConfig = getDefaultConfig({
  appName: "Smelt",
  projectId: WALLETCONNECT_PROJECT_ID,
  chains: [ritualChain],
  transports: {
    [ritualChain.id]: http(import.meta.env.VITE_RITUAL_RPC_URL ?? "https://rpc.ritualfoundation.org"),
  },
  // No SSR; Vite SPA.
  ssr: false,
});
